import axios from "axios";
import axiosRetry from "axios-retry";
import { ApiHead } from "../config/envConfig";
import { useUser } from "../redux/useStore";
import { useDispatch } from "react-redux";
import { setLogoutUser } from "../redux/userSlice";

export const useAxios = () => {
  const user = useUser();
  const dispatch = useDispatch();

  const axiosConfig = {
    baseURL: ApiHead,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    },
  };

  const axiosInstance = axios.create(axiosConfig);

  axiosRetry(axiosInstance, {
    retries: 3,
    retryDelay: (retryCount) => {
      return Math.pow(2, retryCount) * 1000; // 2 sec , 4 sec , 8 sec
    },
    retryCondition: (error) => {
      return !!(
        axiosRetry.isNetworkOrIdempotentRequestError(error) ||
        (error.response?.status && error.response?.status >= 500)
      );
    },
  });

  const interceptor = axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response && error.response?.status === 401) {
        axiosInstance.interceptors.response.eject(interceptor);
        dispatch(setLogoutUser());
        window.location.href = "/login";
      } else {
        // errorHandler(error)
      }

      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
